<svelte:options accessors/>
<script lang="ts">
    import {createEventDispatcher, onMount} from "svelte";
    import NauiCalendar from "../naui/molecules/NauiCalendar.svelte";
    import {hoursOptions} from "../utils";
    import type {submitDataType} from "../utils";
    import ServicesSlideOver from "./ServicesSlideOver.svelte";

    declare const submitData: submitDataType;
    export let month;
    export let year;
    export let idService = null;
    export let calendarType: 'Servicio' | 'Visita' = 'Servicio';
    export let events = [];
    export let eventTags = [];
    export let currentDay: any = {};

    let dispatch = createEventDispatcher();

    let open = false;
    let program = false;
    let horas = hoursOptions;

    let serviceProgramming = {
        time: '08:30 AM',
        date: '',
        observations: '',
        additional: []
    }
    let numDays = 0;

    onMount(() => {
        numDays = serviceProgramming.additional.length;
    });

    function selectDate(ev) {
        open = true;
        program = false;
        currentDay.title = ev.detail.title;
        currentDay.services = ev.detail.data.dayEvents;
        serviceProgramming.date = ev.detail.data.dateIndex;
        serviceProgramming.additional = [];
        numDays = 0;
    }

</script>

<NauiCalendar {events} {eventTags} {year} {month} on:selectDate={selectDate}/>
<ServicesSlideOver bind:open
                   bind:currentDay
                   bind:calendarType
                   bind:idService
                   bind:program
                   bind:serviceProgramming
                   bind:numDays
                   bind:eventTags on:program/>